"use client";
import { cn } from "utils";
import { useCallback } from "react";
import { ShellLink } from "@/src/components";
import NextImage from "@/src/components/NextImage";
import { ContentCategoryEnum } from "@/src/features/api/openData";
import { formatBigNumber, numberStatus } from "@/src/utils";
import { ROUTER_PATH } from "@/src/config";

export const PriceChangePer = ({ assets }: { assets: any[] }) => {
  const getChangePercentage = useCallback((asset: any) => {
    let change = 0;
    if (asset.type === ContentCategoryEnum.STOCK) {
      // 股票：使用 current_price 和 previous_close 计算涨跌幅
      // 涨跌幅（%）= (current_price - previous_close) / previous_close × 100%
      const currentPrice = asset.current_price;
      const previousClose = asset.previous_close;
      if (
        previousClose !== undefined &&
        previousClose !== 0 &&
        currentPrice !== undefined
      ) {
        change = ((currentPrice - previousClose) / previousClose) * 100;
      }
    } else {
      // 加密货币：直接使用 price_change_24h 字段
      change = asset.price_change_24h ?? 0;
    }

    // 处理异常值（NaN、Infinity 等）
    if (!isFinite(change) || isNaN(change)) {
      change = 0;
    }
    return change;
  }, []);
  return (
    <div className="flex gap-2 w-[calc(100vw-28px)] overflow-x-auto hide-scrollbar">
      {assets?.slice(0, 3)?.map((item, index) => {
        const change = getChangePercentage(item);
        const { isNull, absValue } = numberStatus(change);
        const percentage = isNull
          ? "--"
          : `${formatBigNumber(absValue, {
              needFormat: true,
              trimZeros: true,
              precision: 2,
            })}%`;
        const link =
          item.type === ContentCategoryEnum.STOCK
            ? `${ROUTER_PATH.STOCK_DETAIL}/${item.symbol}`
            : `${ROUTER_PATH.CRYPTO_TOKEN}/${item.id}`;
        return (
          <ShellLink
            aria-label="Price Change Per"
            data-openreplay-label={`Price Change Per Link | ${link}`}
            id="lnk-price-change-per"
            key={index}
            href={link}
            onClick={(e) => {
              e.stopPropagation();
            }}
            className="px-2 py-[6px] chips sm_chips rounded-[6px] border border-border_solid flex gap-1 items-center"
          >
            <div className="rounded-full overflow-hidden w-4 h-4">
              <NextImage
                src={item.logo}
                alt={item.symbol}
                width={16}
                height={16}
              />
            </div>
            <div className="flex items-center">
              <span className="body_medium_s text-content_primary">
                {item.short_name || item.symbol}
              </span>
              <span
                className={cn(
                  "body_medium_s text-center pl-[2px] md:block hidden",
                  change >= 0
                    ? "text-content_accent1_primary"
                    : "text-content_accent2_primary",
                )}
              >
                {change >= 0 ? "+" : "-"}
                {percentage}
              </span>
            </div>
          </ShellLink>
        );
      })}
    </div>
  );
};
